
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4493_132)"}},[_c('path',{attrs:{"d":"M1.857 1.713h9.74v9.74h-9.74v-9.74z","fill":"#F35325"}}),_c('path',{attrs:{"d":"M12.57 1.713h9.74v9.74h-9.74v-9.74z","fill":"#81BC06"}}),_c('path',{attrs:{"d":"M1.857 12.426h9.74v9.74h-9.74v-9.74z","fill":"#05A6F0"}}),_c('path',{attrs:{"d":"M12.57 12.426h9.74v9.74h-9.74v-9.74z","fill":"#FFBA08"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4493_132"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.883 .74)","d":"M0 0h22.4v22.4H0z"}})])])])
          )
        }
      }
    